import { z } from "zod";
export var ImageSource;
(function (ImageSource) {
    ImageSource["CONTENTSTACK"] = "contentstack";
    ImageSource["DATADRAGON"] = "ddragon";
    ImageSource["YOUTUBE"] = "youtube";
    ImageSource["WEB"] = "web";
    ImageSource["SANITY"] = "sanity";
})(ImageSource || (ImageSource = {}));
export const ImageSourceSchema = z.nativeEnum(ImageSource);
export var FocalPoint;
(function (FocalPoint) {
    FocalPoint["CENTER"] = "center";
    FocalPoint["RIGHT"] = "right";
    FocalPoint["LEFT"] = "left";
    FocalPoint["TOP"] = "top";
    FocalPoint["BOTTOM"] = "bottom";
})(FocalPoint || (FocalPoint = {}));
export const FocalPointSchema = z.nativeEnum(FocalPoint);
export const ImageFitSchema = z.union([z.literal("width"), z.literal("height")]);
export const DimensionSchema = z.object({
    height: z.number(),
    width: z.number(),
});
export const CommonImageDataSchema = z.object({
    url: z.string(),
    accessibilityText: z.string().optional(),
    focalPoint: FocalPointSchema.optional(),
});
export const ContentstackImageAssetSchema = CommonImageDataSchema.extend({
    type: z.literal(ImageSource.CONTENTSTACK),
    dimensions: DimensionSchema.optional(),
    dimension: DimensionSchema.optional(),
});
export const SanityImageAssetSchema = CommonImageDataSchema.extend({
    type: z.literal(ImageSource.SANITY),
    dimensions: DimensionSchema.optional(),
    dimension: DimensionSchema.optional(),
});
export const DataDragonImageAssetSchema = CommonImageDataSchema.extend({
    type: z.literal(ImageSource.DATADRAGON),
});
export const YoutubeImageAssetSchema = CommonImageDataSchema.extend({
    type: z.literal(ImageSource.YOUTUBE),
});
export const WebImageAssetSchema = CommonImageDataSchema.extend({
    type: z.literal(ImageSource.WEB),
});
export const ImageAssetSchema = z.discriminatedUnion("type", [
    ContentstackImageAssetSchema,
    SanityImageAssetSchema,
    DataDragonImageAssetSchema,
    YoutubeImageAssetSchema,
    WebImageAssetSchema,
]);
export const ResponsiveImageSchema = z.object({
    desktop: ImageAssetSchema,
    tablet: ImageAssetSchema.optional(),
    mobile: ImageAssetSchema.optional(),
});
//# sourceMappingURL=types.js.map